import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Row, Col, Modal, Spinner, Form, Button, Card } from "react-bootstrap";
import { Input, Label } from 'reactstrap';
import Select from 'react-select';
import empresas from 'api/empresas';
import { AccountContext } from 'components/Account/Account';
import generarDocumentoManual from 'api/generarDocumentoManual';
import getDevicesByTenant from 'api/getDevicesByTenant';

const GenerarDocumentoManual = () => {

    const { getSession } = useContext(AccountContext);

    const [empresaList, setEmpresaList] = useState([]);
    const [rut, setRut] = useState('');
    const [tenantId, setTenantId] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState(39);
    const [valorTotal, setValorTotal] = useState('');
    const [valorNeto, setValorNeto] = useState('');
    const [valorIva, setValorIva] = useState('');
    const [fechaEmision, setFechaEmision] = useState(new Date().toISOString().slice(0, 10));
    const [horaEmision, setHoraEmision] = useState(new Date().toTimeString().slice(0, 5));
    const [nombre, setNombre] = useState('');
    const [descAdicional, setDescAdicional] = useState('');
    const [tipoPago, setTipoPago] = useState('efectivo');
    const [deviceId, setDeviceId] = useState('');
    const [deviceOptions, setDeviceOptions] = useState([]);
    const [deviceLoading, setDeviceLoading] = useState(false);
    const [autoCalcMontos, setAutoCalcMontos] = useState(true);
    const [ivaPercent, setIvaPercent] = useState(19);

    const [show, setShow] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [responseData, setResponseData] = useState(null);

    const formatMiles = (value) => {
        if (value === '' || value === null || value === undefined) return '';
        const num = Number(value);
        if (isNaN(num)) return '';
        return num.toLocaleString('es-CL');
    };

    const parseMiles = (str) => {
        const digits = String(str).replace(/\D/g, '');
        return digits === '' ? '' : Number(digits);
    };

    const formatHoraMask = (str) => {
        let digits = String(str).replace(/\D/g, '').slice(0, 4);
        if (digits.length === 0) return '';
        if (digits[0] > '2') digits = '2' + digits.slice(1);
        if (digits.length >= 2) {
            let h1 = digits[1];
            if (digits[0] === '2' && h1 > '3') h1 = '3';
            digits = digits[0] + h1 + digits.slice(2);
        }
        if (digits.length >= 3) {
            let m0 = digits[2];
            if (m0 > '5') m0 = '5';
            digits = digits.slice(0, 2) + m0 + digits.slice(3);
        }
        if (digits.length <= 2) return digits;
        return `${digits.slice(0, 2)}:${digits.slice(2)}`;
    };

    const HORA_24H_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;

    const TEXTO_REGEX = /^[A-Za-zÑñ0-9\s.,\-/#()º]*$/;

    const limpiarTildesYApostrofes = (value) => {
        if (typeof value !== 'string') return value;
        return value
            .replace(/['‘’ʼʻ`´]/g, '')
            .split('')
            .map((ch) => {
                if (ch === 'ñ' || ch === 'Ñ') return ch;
                return ch.normalize('NFD').replace(/[̀-ͯ]/g, '');
            })
            .join('');
    };

    const optionsdoc = [
        { value: 39, label: '39 - Boleta Electrónica' },
        { value: 41, label: '41 - Boleta Exenta' },
    ];

    const optionsTipoPago = [
        { value: 'efectivo', label: '1 - Efectivo' },
        { value: 'tarjeta', label: '2 - Tarjeta' },
       
    ];

    const empresaOptions = empresaList
        // .filter((e) => e.rut !== 1 && e.rut !== '1')
        .map((e) => ({
            value: e.rut,
            label: e.rut + ' - ' + e.name + (e.status === 'suspended' ? ' (Deshabilitada)' : ''),
            tenant_id: e.tenant_id,
            status: e.status,
            isDisabled: e.status === 'suspended',
        }));

    useEffect(() => {
        getSession().then((session) => {
            empresas.getEmpresas(session.idToken.jwtToken)
                .then((response) => {
                    setEmpresaList(response.data);
                })
                .catch((error) => {
                    if (axios.isCancel(error)) return false;
                    console.log(error);
                });
        });
    }, []);

    useEffect(() => {
        async function fetchDevices() {
            if (!tenantId) {
                setDeviceOptions([]);
                setDeviceId('');
                return;
            }
            setDeviceLoading(true);
            setDeviceOptions([]);
            setDeviceId('');
            try {
                const idToken = await getSession().then((session) => session.idToken.jwtToken);
                const response = await getDevicesByTenant(idToken, tenantId);
                const records = response.data.records || response.data || [];
                const options = records.map((d) => {
                    const name = d.device_name || d.name || d.deviceName || '';
                    return {
                        value: d.device_id,
                        label: name ? `${d.device_id} - ${name}` : d.device_id,
                    };
                });
                setDeviceOptions(options);
            } catch (error) {
                console.log(error);
                setDeviceOptions([]);
            } finally {
                setDeviceLoading(false);
            }
        }
        fetchDevices();
    }, [tenantId]);

    const handleClose = () => {
        setShow(false);
    };

    const validarCampos = () => {
        if (!rut) return 'Por favor seleccione una empresa';
        const empresaSel = empresaList.find((e) => e.rut === rut);
        if (empresaSel && empresaSel.status === 'suspended') {
            return 'La empresa seleccionada está deshabilitada. No es posible generar documentos.';
        }
        if (!tipoDocumento) return 'Por favor seleccione un tipo de documento';
        if (valorTotal === '' || isNaN(Number(valorTotal))) return 'Ingrese un valor total válido';
        if (valorNeto === '' || isNaN(Number(valorNeto))) return 'Ingrese un valor neto válido';
        if (valorIva === '' || isNaN(Number(valorIva))) return 'Ingrese un valor IVA válido';
        if (!fechaEmision) return 'Ingrese la fecha de emisión';
        const hoy = new Date().toISOString().slice(0, 10);
        if (fechaEmision > hoy) return 'La fecha de emisión no puede ser mayor al día actual';
        if (!horaEmision) return 'Ingrese la hora de emisión';
        if (!HORA_24H_REGEX.test(horaEmision)) return 'La hora de emisión debe estar en formato HH:MM (24h)';
        if (!tipoPago) return 'Seleccione el tipo de pago';
        if (!deviceId) return 'Ingrese el device_id';
        if (nombre && !TEXTO_REGEX.test(nombre)) {
            return 'El nombre contiene caracteres no permitidos (tildes o caracteres especiales).';
        }
        if (descAdicional && !TEXTO_REGEX.test(descAdicional)) {
            return 'La descripción adicional contiene caracteres no permitidos (tildes o caracteres especiales).';
        }
        return null;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const error = validarCampos();
        if (error) {
            setSuccess(false);
            setMessage(error);
            setLoading(false);
            setShow(true);
            return;
        }

        setShowConfirm(true);
    };

    const handleConfirmSubmit = async () => {
        setShowConfirm(false);
        setLoading(true);
        setShow(true);

        const params = {
            rut,
            tipoDocumento: Number(tipoDocumento),
            valorTotal: Number(valorTotal),
            valorNeto: Number(valorNeto),
            valorIva: Number(valorIva),
            fechaEmision,
            horaEmision,
            nombre,
            descAdicional,
            tipoPago,
            device_id: deviceId,
        };

        try {
            const idToken = await getSession().then((session) => session.idToken.jwtToken);
            const resp = await generarDocumentoManual(params, idToken);
            console.log(resp);
            let body = resp.data;
            if (body && typeof body.body === 'string') {
                try { body = JSON.parse(body.body); } catch (_) { /* deja body tal cual */ }
            }
            setResponseData(body || {});
            setSuccess(true);
            setMessage('Documento generado correctamente');
            setLoading(false);
        } catch (err) {
            console.log(err);
            setSuccess(false);
            setResponseData(null);
            const apiMsg = err?.response?.data?.message || err?.message || 'Error al generar el documento';
            setMessage('Error al generar el documento: ' + apiMsg);
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!autoCalcMontos) return;
        if (valorTotal === '' || isNaN(Number(valorTotal))) {
            setValorNeto('');
            setValorIva('');
            return;
        }
        const totalNum = Number(valorTotal);
        if (Number(tipoDocumento) === 41) {
            setValorNeto(totalNum);
            setValorIva(0);
            return;
        }
        const ivaPct = Number(ivaPercent) || 0;
        const neto = Math.round(totalNum / (1 + ivaPct / 100));
        setValorNeto(neto);
        setValorIva(totalNum - neto);
    }, [valorTotal, ivaPercent, tipoDocumento, autoCalcMontos]);

    return (
        <>
            <Container fluid>
                <Row>
                    <Col md="12">
                        <Card className="strpied-tabled-with-hover">
                            <Card.Header>
                                <Card.Title as="h4">Genera documento manual</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Label>Empresa</Label>
                                                <Select
                                                    options={empresaOptions}
                                                    onChange={(opt) => {
                                                        setRut(opt.value);
                                                        setTenantId(opt.tenant_id);
                                                    }}
                                                    placeholder="Seleccione empresa"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Label>Tipo de documento</Label>
                                                <Select
                                                    options={optionsdoc}
                                                    defaultValue={optionsdoc[0]}
                                                    onChange={(opt) => setTipoDocumento(opt.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="6">
                                            <Form.Group className="mb-3 mt-2">
                                                <div className="d-flex align-items-center">
                                                    <Input
                                                        type="checkbox"
                                                        id="autoCalcMontos"
                                                        checked={autoCalcMontos}
                                                        onChange={(e) => setAutoCalcMontos(e.target.checked)}
                                                        style={{ position: 'static', marginLeft: 0, marginRight: 8 }}
                                                    />
                                                    <Label htmlFor="autoCalcMontos" className="mb-0" style={{ cursor: 'pointer' }}>
                                                        Calcular neto e IVA automáticamente
                                                    </Label>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Label>IVA (%)</Label>
                                                <Input
                                                    type="number"
                                                    value={ivaPercent}
                                                    onChange={(e) => setIvaPercent(e.target.value)}
                                                    disabled={!autoCalcMontos || Number(tipoDocumento) === 41}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Label>Valor total</Label>
                                                <Input
                                                    type="text"
                                                    inputMode="numeric"
                                                    value={formatMiles(valorTotal)}
                                                    onChange={(e) => setValorTotal(parseMiles(e.target.value))}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Label>Valor neto</Label>
                                                <Input
                                                    type="text"
                                                    inputMode="numeric"
                                                    value={formatMiles(valorNeto)}
                                                    onChange={(e) => setValorNeto(parseMiles(e.target.value))}
                                                    disabled={autoCalcMontos}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Label>Valor IVA</Label>
                                                <Input
                                                    type="text"
                                                    inputMode="numeric"
                                                    value={formatMiles(valorIva)}
                                                    onChange={(e) => setValorIva(parseMiles(e.target.value))}
                                                    disabled={autoCalcMontos}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Label>Fecha de emisión</Label>
                                                <Input
                                                    type="date"
                                                    value={fechaEmision}
                                                    max={new Date().toISOString().slice(0, 10)}
                                                    onChange={(e) => setFechaEmision(e.target.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Label>Hora de emisión (HH:MM)</Label>
                                                <Input
                                                    type="text"
                                                    inputMode="numeric"
                                                    maxLength={5}
                                                    placeholder="HH:MM"
                                                    value={horaEmision}
                                                    onChange={(e) => setHoraEmision(formatHoraMask(e.target.value))}
                                                    invalid={horaEmision !== '' && !HORA_24H_REGEX.test(horaEmision)}
                                                    valid={horaEmision !== '' && HORA_24H_REGEX.test(horaEmision)}
                                                />
                                                {horaEmision !== '' && !HORA_24H_REGEX.test(horaEmision) && (
                                                    <small style={{ color: 'red' }}>Formato inválido. Use HH:MM (24h).</small>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col md="4">
                                            <Form.Group className="mb-3">
                                                <Label>Tipo de pago</Label>
                                                <Select
                                                    options={optionsTipoPago}
                                                    defaultValue={optionsTipoPago[0]}
                                                    onChange={(opt) => setTipoPago(opt.value)}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="12">
                                            <Form.Group className="mb-3">
                                                <Label>Nombre producto / servicio</Label>
                                                <Input
                                                    value={nombre}
                                                    onChange={(e) => setNombre(limpiarTildesYApostrofes(e.target.value))}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="12">
                                            <Form.Group className="mb-3">
                                                <Label>Descripción adicional</Label>
                                                <Input
                                                    type="textarea"
                                                    rows="3"
                                                    value={descAdicional}
                                                    onChange={(e) => setDescAdicional(limpiarTildesYApostrofes(e.target.value))}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="6">
                                            <Form.Group className="mb-3">
                                                <Label>Device</Label>
                                                <Select
                                                    options={deviceOptions}
                                                    value={deviceOptions.find((o) => o.value === deviceId) || null}
                                                    onChange={(opt) => setDeviceId(opt ? opt.value : '')}
                                                    isLoading={deviceLoading}
                                                    isDisabled={!rut || deviceLoading}
                                                    placeholder={!rut ? 'Seleccione una empresa primero' : 'Seleccione un device'}
                                                    noOptionsMessage={() => 'Sin devices para esta empresa'}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Button onClick={handleSubmit}>Generar documento</Button>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <Modal show={showConfirm} onHide={() => setShowConfirm(false)} backdrop="static">
                <Modal.Header>
                    <Modal.Title>Confirmar envío del documento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Revisa los datos antes de generar el documento:</p>
                    <ul className="list-unstyled mb-0">
                        <li><strong>Empresa (RUT):</strong> {rut}</li>
                        <li><strong>Tipo de documento:</strong> {optionsdoc.find((o) => o.value === Number(tipoDocumento))?.label || tipoDocumento}</li>
                        <li><strong>Valor total:</strong> {formatMiles(valorTotal)}</li>
                        <li><strong>Valor neto:</strong> {formatMiles(valorNeto)}</li>
                        <li><strong>Valor IVA:</strong> {formatMiles(valorIva)}</li>
                        <li><strong>Fecha emisión:</strong> {fechaEmision}</li>
                        <li><strong>Hora emisión:</strong> {horaEmision}</li>
                        <li><strong>Nombre producto/servicio:</strong> {nombre || <em className="text-muted">(vacío)</em>}</li>
                        <li><strong>Descripción adicional:</strong> {descAdicional || <em className="text-muted">(vacío)</em>}</li>
                        <li><strong>Tipo de pago:</strong> {optionsTipoPago.find((o) => o.value === tipoPago)?.label || tipoPago}</li>
                        <li><strong>Device:</strong> {deviceOptions.find((o) => o.value === deviceId)?.label || deviceId}</li>
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirm(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleConfirmSubmit}>
                        Confirmar y generar
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Header>
                    <Modal.Title>
                        {loading ? 'Generando documento' : success ? 'Documento generado' : 'Error'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading && (
                        <Spinner animation="border" role="status" className="sticky-top" />
                    )}
                    {!loading && (
                        <>
                            <p>{message}</p>
                            {success && responseData && (
                                <div>
                                    <p><strong>Rut:</strong> {rut}</p>
                                    <p><strong>Tipo de documento:</strong> {tipoDocumento}</p>
                                    {responseData.folio !== undefined && (
                                        <p><strong>Folio:</strong> {responseData.folio}</p>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {!loading && (
                        <Button variant="secondary" onClick={handleClose}>
                            Cerrar
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default GenerarDocumentoManual;
